import query from "../../server/constants.api";
import useFetch from "../../server/useFetch";
import { WidgetCard } from "../Global/Atomics/WidgetCard";
import { GoogleMap } from "../Global/Maps/GoogleMap";
import { io } from "socket.io-client";
import { useEffect, useState } from "react";
import { websocketPort } from "../../server/websocketPort";
import Theme from '../../styles/Theme/Theme';

const socket = io(websocketPort, {
    transports: ['websocket'],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10000,
    reconnectionAttempts: Infinity,
    pingTimeout: 30000,
    pingInterval: 15000,
});

export const MapsWidget = ({ mapOverrides = {} }) => {
    // const [incidents, setIncidents] = useState();
    const [realtimeBus, setRealtimeBus] = useState();

    // const { data: mapConfigurationData, isLoading: mapConfigurationLoading, refetch: refetchMapConfiguration } = useFetch(query.path.mapConfiguration, 'getMapConfiguration');
    const { data: incidentsData, isFetching: incidentsIsFetching, refetch: refetchIncidents } = useFetch('/incidents/map/items', 'getIncidents', {
        id: '12cd9418-c829-07cb-43f1-d1d57293a4a1',
        tenant: 'TOP/CASCAIS/CM CASCAIS',
    }, 900000, query.middlewareCommandURL);

    const { data: busData, isFetching: busIsFetching } = useFetch(query.path.realtimeBus, 'getRealtimeBus', null, 60000);
    useEffect(() => {
        if (busData) {
            setRealtimeBus(busData)
        }
    }, [busData])

    useEffect(() => {
        const FORCE_REFETCH_INTERVAL = 5 * 60 * 1000; // 5 minutes
        const intervalId = setInterval(() => {
            console.log("[MapsWidget] Periodic forced refetch of incidents");
            refetchIncidents();
        }, FORCE_REFETCH_INTERVAL);
        return () => clearInterval(intervalId);
    }, [refetchIncidents]);

    useEffect(() => {
        const handler = (text) => {
            console.log("Refetch Incidents");
            refetchIncidents();
        };
        const onReconnect = () => {
            console.log("Socket reconnected - refetching incidents");
            refetchIncidents();
        };
        const onDisconnect = (reason) => {
            console.warn("[MapsWidget] Socket disconnected:", reason);
        };
        const onError = (err) => {
            console.error("[MapsWidget] Socket error:", err);
        };
        socket.on("manageIncident", handler);
        socket.on("connect", onReconnect);
        socket.on("disconnect", onDisconnect);
        socket.on("connect_error", onError);
        return () => {
            socket.off("manageIncident", handler);
            socket.off("connect", onReconnect);
            socket.off("disconnect", onDisconnect);
            socket.off("connect_error", onError);
        };
    }, [refetchIncidents])

    // if (!mapConfigurationLoading && mapConfigurationData.data?.styles && mapConfigurationData.data?.hide.length) {
    //     mapConfigurationData.data?.hide.map((el) => {
    //         mapStyles[mapConfigurationData.data?.styles].push(
    //             {
    //                 featureType: "poi." + el,
    //                 stylers: [{ visibility: "off" }],
    //             },
    //         )
    //     })

    // }

    return (
        <WidgetCard margin={Theme.spacing.videowall.xxs}>
            {/* {!incidentsIsFetching ? */}
            <GoogleMap configurations={{ ...mapConfiguration, ...mapOverrides }} incidents={incidentsData} realtimebus={realtimeBus} />
            {/* : <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}><Spinner stroke="green" /></div>} */}
        </WidgetCard>
    )
}

const mapConfiguration = {
    "mapId": "15fb961c1d0a757",
    "lat": 38.710357,
    "lng": -9.369001,
    "zoom": 13.9,
    "disableDefaultUI": true,
    "heading": 10,
    "tilt": 0,
    "showTraffic": true,
    "showTransit": false,
    "showIncidents": true,
    "showRealTimeVehicle": false,
    "showTripUpdate": true,
    "showIncidentsTooltips": true,
    "showRealTimeVehicleTooltip": true,
    "styles": "default",
    "hide": [
        "attraction",
        "sports_complex",
        "place_of_worship",
        "business",
        "government",
        "medical",
        "park",
        "school",
        "shopping",
        "restaurant"
    ]
};